import api from './api';
import { AttendanceStatusResponse, AttendanceStatsResponse } from '../types/attendance';

// 출근하기
export const checkIn = async () => {
  const response = await api.post('/attendance/check-in');
  return response.data;
};

// 퇴근하기
export const checkOut = async () => {
  const response = await api.post('/attendance/check-out');
  return response.data;
};

// 오늘 출근 상태
export const getMyStatus = async (): Promise<AttendanceStatusResponse> => {
  const response = await api.get('/attendance/my-status');
  return response.data;
};

// 출근 통계
export const getAttendanceStats = async (): Promise<AttendanceStatsResponse> => {
  const response = await api.get('/attendance/stats');
  return response.data;
};
